import { localDb } from '../localDb';

export const DEV_USER_ID = 'dev-user';
const SEED_FLAG = 'branta_buddy_seeded_v1';
const DAY_MS = 24 * 60 * 60 * 1000;

const MARCO_BAUER = {
	id: 'DR-1042',
	fullName: 'Marco Bauer',
	driverCard: 'DE-BY-2034891',
	isActive: true,
	phone: '+49 89 12345678',
	email: 'marco.bauer@flixbus.com',
	currentHomeBase: {
		id: 'hb-muc-d1',
		effectiveTimestamp: '2022-03-01T08:00:00Z',
		city: { name: 'Munich', timezone: 'Europe/Berlin' },
	},
	permanentHomeBase: {
		id: 'hb-muc-d1',
		effectiveTimestamp: '2022-03-01T00:00:00Z',
		city: { name: 'Munich' },
	},
	currentLocation: {
		city: { name: 'Munich' },
		station: { name: 'Munich Central Bus Station', code: 'MUC' },
		fromTimestamp: '2025-10-12T06:30:00Z',
	},
	currentRun: { id: 'run-201', name: 'MUC → FRA Line 08' },
	currentJobs: [{ id: 'j-501', code: 'DRV-501' }],
	currentEmploymentType: {
		id: 'emp-1',
		employmentType: 'fullTime',
		effectiveTimestamp: '2022-03-01T00:00:00Z',
	},
	driverLicenseExpiresAt: '2027-08-15',
	drugTestExpiresAt: '2026-03-01',
	medicalCheckExpiresAt: '2026-11-20',
	nextAvailability: '2025-10-13T06:00:00Z',
	hoursTracking: {
		drivingMinutesBalance: 240,
		drivingMinutesLimit: 540,
		dutyMinutesBalance: 300,
		dutyMinutesLimit: 660,
		eightDaysDutyMinutesBalance: 1800,
		eightDaysDutyMinutesLimit: 3600,
	},
	lastWorkAssignment: {
		fromTimestamp: '2025-10-12T06:30:00Z',
		toTimestamp: '2025-10-12T14:00:00Z',
		activity: {
			fromStation: { name: 'Munich Central Bus Station', code: 'MUC' },
			toStation: { name: 'Frankfurt (Main) Bus Station', code: 'FRA', city: { name: 'Frankfurt' } },
		},
	},
	holdDowns: [],
};

const now = Date.now();

const SEED_CONVERSATIONS = [
	{
		conversationId: 'seed-marco-bauer',
		baseTime: now - 2 * 60_000,
		messages: [
			{
				role: 'user',
				text: 'Show me details for Marco Bauer',
				card: null,
				offsetMs: 0,
			},
			{
				role: 'assistant',
				text: "Here's what I found for that crew member:",
				card: { type: 'crewMember', data: MARCO_BAUER },
				offsetMs: 1_500,
			},
			{
				role: 'user',
				text: 'What route is he on?',
				card: null,
				offsetMs: 90_000,
			},
			{
				role: 'assistant',
				text: 'Marco Bauer is currently on run MUC → FRA Line 08, departing from Munich Central Bus Station.',
				card: null,
				offsetMs: 92_000,
			},
		],
	},
	{
		conversationId: 'seed-delayed-routes',
		baseTime: now - DAY_MS - 60 * 60_000,
		messages: [
			{
				role: 'user',
				text: 'Which routes had delays over 20 min yesterday?',
				card: null,
				offsetMs: 0,
			},
			{
				role: 'assistant',
				text: 'Routes MUC → BER and HAM → FRA both had delays exceeding 20 minutes yesterday. MUC → BER was delayed 34 min due to traffic near Nuremberg; HAM → FRA was 22 min late due to a late crew change.',
				card: null,
				offsetMs: 1_800,
			},
		],
	},
	{
		conversationId: 'seed-onboarding',
		baseTime: now - 5 * DAY_MS,
		messages: [
			{
				role: 'user',
				text: 'List drivers onboarded this month',
				card: null,
				offsetMs: 0,
			},
			{
				role: 'assistant',
				text: '4 crew members were onboarded in October: Lukas Braun (Munich), Maria Held (Berlin), Felix König (Hamburg), Sara Meier (Frankfurt).',
				card: null,
				offsetMs: 1_200,
			},
		],
	},
];

export async function seedBuddyChatHistory() {
	if (localStorage.getItem(SEED_FLAG)) return false;

	const rows = [];

	for (const conv of SEED_CONVERSATIONS) {
		for (const msg of conv.messages) {
			rows.push({
				userId: DEV_USER_ID,
				conversationId: conv.conversationId,
				role: msg.role,
				text: msg.text,
				card: msg.card ?? null,
				createdAt: conv.baseTime + msg.offsetMs,
				status: 'ok',
			});
		}
	}

	await localDb.buddyMessages.bulkAdd(rows);

	localStorage.setItem(SEED_FLAG, '1');

	return true;
}

export async function clearSeedData() {
	const seedIds = SEED_CONVERSATIONS.map((c) => c.conversationId);

	for (const conversationId of seedIds) {
		await localDb.buddyMessages
			.where('[userId+conversationId]')
			.equals([DEV_USER_ID, conversationId])
			.delete();
	}

	localStorage.removeItem(SEED_FLAG);
}
